import { fork } from 'redux-saga/effects'
import watchLoadWhitelabels from './watchLoadWhitelabels'

export default function* dashboard() {
  yield fork(watchLoadWhitelabels)
}
